<template>
    <iframe src="../quest/Quest89-1.0-web/index.html" frameborder="0"></iframe>
</template>
<script>
    export default {
    name: "InformatikQuest"
    };
</script>
<style scoped>
    iframe {
        width: 100%;
        height: 100vh;
        border: none;
    }
</style>